/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for tenant enrollment
 * @export
 * @interface TenantEnrollmentResponse
 */
export interface TenantEnrollmentResponse {
    /**
     * Whether the enrollment was successful
     * @type {boolean}
     * @memberof TenantEnrollmentResponse
     */
    success?: boolean;
    /**
     * Error message if enrollment failed
     * @type {string}
     * @memberof TenantEnrollmentResponse
     */
    error?: string;
    /**
     * Tenant ID if enrollment was successful
     * @type {string}
     * @memberof TenantEnrollmentResponse
     */
    tenantId?: string;
    /**
     * Tenant name
     * @type {string}
     * @memberof TenantEnrollmentResponse
     */
    tenantName?: string;
    /**
     * Enrollment status
     * @type {string}
     * @memberof TenantEnrollmentResponse
     */
    enrollmentStatus?: TenantEnrollmentResponseEnrollmentStatusEnum;
    /**
     * Next steps for the user
     * @type {string}
     * @memberof TenantEnrollmentResponse
     */
    nextSteps?: string;
    /**
     * Verification instructions if SSO setup is required
     * @type {string}
     * @memberof TenantEnrollmentResponse
     */
    verificationInstructions?: string;
    /**
     * Azure AD admin consent URL (for enterprise app SSO configuration)
     * @type {string}
     * @memberof TenantEnrollmentResponse
     */
    consentUrl?: string;
}


/**
 * @export
 */
export const TenantEnrollmentResponseEnrollmentStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Suspended: 'suspended',
    Rejected: 'rejected'
} as const;
export type TenantEnrollmentResponseEnrollmentStatusEnum = typeof TenantEnrollmentResponseEnrollmentStatusEnum[keyof typeof TenantEnrollmentResponseEnrollmentStatusEnum];


/**
 * Check if a given object implements the TenantEnrollmentResponse interface.
 */
export function instanceOfTenantEnrollmentResponse(value: object): value is TenantEnrollmentResponse {
    return true;
}

export function TenantEnrollmentResponseFromJSON(json: any): TenantEnrollmentResponse {
    return TenantEnrollmentResponseFromJSONTyped(json, false);
}

export function TenantEnrollmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantEnrollmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'tenantName': json['tenant_name'] == null ? undefined : json['tenant_name'],
        'enrollmentStatus': json['enrollment_status'] == null ? undefined : json['enrollment_status'],
        'nextSteps': json['next_steps'] == null ? undefined : json['next_steps'],
        'verificationInstructions': json['verification_instructions'] == null ? undefined : json['verification_instructions'],
        'consentUrl': json['consent_url'] == null ? undefined : json['consent_url'],
    };
}

export function TenantEnrollmentResponseToJSON(json: any): TenantEnrollmentResponse {
    return TenantEnrollmentResponseToJSONTyped(json, false);
}

export function TenantEnrollmentResponseToJSONTyped(value?: TenantEnrollmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'error': value['error'],
        'tenant_id': value['tenantId'],
        'tenant_name': value['tenantName'],
        'enrollment_status': value['enrollmentStatus'],
        'next_steps': value['nextSteps'],
        'verification_instructions': value['verificationInstructions'],
        'consent_url': value['consentUrl'],
    };
}

